import { render, staticRenderFns } from "./ToolsPage.vue?vue&type=template&id=be3eb2d0&scoped=true&"
import script from "./ToolsPage.vue?vue&type=script&lang=js&"
export * from "./ToolsPage.vue?vue&type=script&lang=js&"
import style0 from "./ToolsPage.vue?vue&type=style&index=0&id=be3eb2d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be3eb2d0",
  null
  
)

export default component.exports